import { sniff } from '@/util'
import queryString from 'query-string'

const getStatusBarInfo = function () {
  return new Promise(function (resolve, reject) {
    try {
      if (sniff.isUboxAndroidApp) {
        const searchObj = queryString.parse(location.search) ?? {}
        resolve({
          height: ~~searchObj.statusBar_height || 30,
        })
      } else if (sniff.isUboxIosApp) {
        let _height = 44
        sniff.ioIPhoneX ? _height = 44 : _height = 20
        resolve({
          height: _height,
        })
      }
    } catch (e) {
      reject({
        height: 0,
      })
    }
  })
}

export default getStatusBarInfo